import React from 'react'
import Logo from '@/components/Featured/Mundial62/Logo'
import styled, { keyframes } from 'styled-components'
import { StaticImage } from 'gatsby-plugin-image'

const move = keyframes`
  0% {
      transform: scale(1.3) translate3d( -12%, 12%, 0 );
  }
  25% {
      transform: scale(1.3) translate3d( 12%, -12%, 0 );
  }
  50% {
      transform: scale(1.3) translate3d( 12%, 12%, 0 );
  }
  75% {
      transform: scale(1.3) translate3d( -12%, -12%, 0 );
  }
  100% {
      transform: scale(1.3) translate3d( -12%, 12%, 0 );
  }
`

const moveResp = keyframes`
  0% {
      transform: scale(2) translate3d( -3%, 3%, 0 );
  }
  25% {
      transform: scale(2) translate3d( 3%, -3%, 0 );
  }
  50% {
      transform: scale(2) translate3d( 3%, 3%, 0 );
  }
  75% {
      transform: scale(2) translate3d( -3%, -3%, 0 );
  }
  100% {
      transform: scale(2  ) translate3d( -3%, 3%, 0 );
  }
`

const Wrap = styled.div`
  position: relative;
  min-height: 80vh;
  background-color: black;
  @media (max-width: 768px) {
    min-height: calc(100vh - 4rem);
  }
  @media (max-width: 380px) {
    min-height: calc(110vh - 4rem);
  }
`
const ContentWrap = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  width: 100%;
  padding: 1rem;
  z-index: 2;
  display: flex;
  align-items: flex-end;
  justify-content: center;
`
const Excerpt = styled.p`
  color: white;
  font-family: 'Futura', sans-serif;
  padding: 2rem;
  background-color: #1f4224;
  text-align: justify;
  margin-top: 2rem;
  @media (max-width: 768px) {
    padding: 1rem;
    margin-top: 1rem;
  }
  @media (max-height: 630px) {
    padding: 1rem;
    margin-top: 1rem;
  }
`
const Content = styled.div`
  max-width: 600px;
  background-color: #e9d2a9;
  padding: 2rem;
  @media (max-width: 768px) {
    padding: 1rem;
  }
  @media (max-height: 630px) {
    padding: 1rem;
  }
`

const StLogo = styled(Logo)`
  height: 20vh;
  margin: 0 auto;
`

const Bg = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  right: 0;
  bottom: 0;
  figure {
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    background-color: black;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    .gatsby-image-wrapper {
      width: 1920px;
      height: 1920px;
      transform: scale(1.3) translate3d(-12%, 12%, 0);
      animation-direction: alternate;
      animation: ${move} 30s infinite;
      transform-origin: center center;
      animation-timing-function: ease;
      @media (max-width: 768px) {
        transform: scale(2) translate3d(-3%, 3%, 0);
        animation: ${moveResp} 30s infinite;
      }
    }
  }
`

const Hero = ({ bajada }) => {
  return (
    <Wrap>
      <ContentWrap>
        <Content>
          <StLogo />
          <Excerpt dangerouslySetInnerHTML={{ __html: bajada }}></Excerpt>
        </Content>
      </ContentWrap>
      <Bg>
        <figure>
          <StaticImage src="./bg-hero.jpg" alt="" />
        </figure>
      </Bg>
    </Wrap>
  )
}

export default Hero
